import DownloadBanner from "./DownloadBanner";

export default DownloadBanner;
